import { GlobalStore } from '@/store';

export const soundCorrect = () => {
    var soundItem = new Audio('/assets/sound/f4178.mp3');
    soundItem.currentTime = 0;
    soundItem.play();
};
export const soundhalfWrong = () => {
    var soundItem = new Audio('/assets/sound/f2340.mp3');
    soundItem.currentTime = 0;
    soundItem.play();
};
export const soundWrong = () => {
    var soundItem = new Audio('/assets/sound/f2962.mp3');
    soundItem.currentTime = 0;
    soundItem.play();
};
export const soundEnter = () => {
    var soundItem = new Audio('/assets/sound/f4024.mp3');
    soundItem.currentTime = 0;
    soundItem.play();
};
export const soundNext = () => {
    var soundItem = new Audio('/assets/sound/f1372.mp3');
    soundItem.currentTime = 0;
    soundItem.play();
};
export const soundPopup = () => {
    var soundItem = new Audio('/assets/sound/f495.mp3');
    soundItem.currentTime = 0;
    soundItem.play();
};

// export const soundComplete = () => {
//     var soundItem = new Audio('/assets/sound/complete.mp3');
//     soundItem.currentTime = 0;
//     soundItem.play();
// };
// export const soundExit = () => {
//     var soundItem = new Audio('/assets/sound/exit.mp3');
//     soundItem.currentTime = 0;
//     soundItem.play();
// };
// export const soundResult = () => {
//     var soundItem = new Audio('/assets/sound/result.mp3');
//     soundItem.currentTime = 0;
//     soundItem.play();
// };
// export const soundTic = () => {
//     var soundItem = new Audio('/assets/sound/tic.mp3');
//     soundItem.currentTime = 0;
//     soundItem.play();
// };

/**
 * 효과음 재생
 * @param {*} val // 효과음
 */
let playPromise = null;
let soundItem = null;
const test0 = new Audio('/assets/sound/complete.mp3');
const test1 = new Audio('/assets/sound/f4178.mp3');
const test3 = new Audio('/assets/sound/f2340.mp3');
const test2 = new Audio('/assets/sound/f2962.mp3');
const test4 = new Audio('/assets/sound/f4024.mp3');
const test5 = new Audio('/assets/sound/f1372.mp3');
const test6 = new Audio('/assets/sound/f495.mp3');
const test7 = new Audio('/assets/sound/result.mp3');
const test8 = new Audio('/assets/sound/tic.mp3');
export const soundEffect = async (val) => {
    const globalStore = GlobalStore();
    try {
        if (!globalStore?.sound) {
            return false;
        }
        if (soundItem !== null) {
            await soundItem.pause();
            if (playPromise !== undefined) {
                playPromise.then((_) => {}).catch((error) => {});
            }
        }
        if (val === 'complete') {
            soundItem = test0;
        } else if (val === 'correct') {
            soundItem = test1;
        } else if (val === 'halfWrong') {
            soundItem = test2;
        } else if (val === 'wrong') {
            soundItem = test3;
        } else if (val === 'enter') {
            soundItem = test4;
        } else if (val === 'exit') {
            //soundItem = new Audio('/assets/sound/exit.mp3');
        } else if (val === 'next') {
            soundItem = test5;
        } else if (val === 'popup') {
            soundItem = test6;
        } else if (val === 'result') {
            soundItem = test7;
        } else if (val === 'tic') {
            soundItem = test8;
        }
        if (soundItem) {
            try {
                soundItem.currentTime = 0;
                playPromise = soundItem.play();
                if (playPromise !== undefined) {
                    playPromise
                        .then((_) => {})
                        .catch((error) => {
                            console.log('error! :', error);
                        });
                }
            } catch (error) {
                //
            }
        }
    } catch (error) {
        //
    }
};
